// src/pages/PreguntasFrecuentes.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaChevronDown, FaChevronUp, FaQuestionCircle, FaLock, FaMoneyBillWave, FaComments, FaTools, FaArrowLeft } from 'react-icons/fa';
import './AyudaSoporte.css';

const faqItems = [
    {
        category: 'Pagos',
        question: '¿Cómo puedo pagar mis cuotas o mantenimiento?',
        answer: 'Entra a Finanzas. Desde ahí puedes revisar tu estado de cuenta actual y las cuotas actuales del mes.',
        icon: <FaMoneyBillWave />,
    },
    {
        category: 'Pagos',
        question: '¿Dónde descargo mis recibos y comprobantes?',
        answer: 'En Finanzas > Pagos Realizados, puedes ver tus comprobantes de saldos pagados.',
        icon: <FaMoneyBillWave />,
    },
    {
        category: 'Comunicación',
        question: '¿Cómo recibo avisos, comunicados o votaciones?',
        answer: 'En Comunidad verás los comunicados y votaciones vigentes. Si activaste notificaciones, también te llegarán por el canal configurado (push o correo).',
        icon: <FaComments />,
    },
    {
        category: 'Comunicación',
        question: '¿Dónde reporto una incidencia o hago una solicitud?',
        answer: 'Desde Comunidad > Propuestas e incidencias puedes enviar reportes con descripción y adjuntar evidencia. El administrador recibirá el detalle y podrá dar seguimiento.',
        icon: <FaComments />,
    },
    {
        category: 'Seguridad',
        question: '¿Cómo registro visitas o genero un QR de acceso?',
        answer: 'Ingresa a Vigilancia y usa la opción de "+ Generar QR para Invitado" para crear pases con QR. Comparte el código con tu invitado; la caseta puede escanearlo para validar el acceso.',
        icon: <FaLock />,
    },
    {
        category: 'Seguridad',
        question: '¿Qué hago si el QR no se lee en caseta?',
        answer: 'Revisa que el pase esté vigente. Aumenta el brillo de tu pantalla y asegúrate de que el código no esté recortado. Si persiste, genera un nuevo pase desde Vigilancia.',
        icon: <FaLock />,
    },
    {
        category: 'Administración',
        question: '¿Cómo administro horarios y reglas de amenidades?',
        answer: 'En Amenidades puedes consultar horarios, reglas y disponibilidad de cada recurso. Los administradores autorizados pueden ajustar bloques y restricciones desde Configuraciones > Amenidades y horarios.',
        icon: <FaTools />,
    },
    {
        category: 'Administración',
        question: '¿Cómo actualizo mis datos o los de mi fraccionamiento?',
        answer: 'Desde Configuraciones > Editar perfil puedes actualizar tu información personal. Los administradores con permiso pueden ajustar configuraciones financieras, horarios y datos del fraccionamiento en la sección de Ajustes.',
        icon: <FaTools />,
    },
];

const PreguntasFrecuentes = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggle = (index) => {
        setOpenIndex((prev) => (prev === index ? null : index));
    };

    return (
        <div className="help-page">
            <Link to="/configuraciones" className="back-button">
                <FaArrowLeft /> Volver
            </Link>
            <div className="help-hero">
                <div className="help-hero-icon"><FaQuestionCircle /></div>
                <div>
                    <h2>Preguntas Frecuentes</h2>
                    <p>Respuestas rápidas sobre pagos, comunicación, seguridad y administración del fraccionamiento.</p>
                </div>
            </div>

            <div className="help-card">
                <div className="faq-list">
                    {faqItems.map((item, index) => {
                        const isOpen = openIndex === index;
                        return (
                            <div key={item.question} className={`faq-item ${isOpen ? 'open' : ''}`}>
                                <button type="button" className="faq-header" onClick={() => toggle(index)} aria-expanded={isOpen}>
                                    <div className="faq-meta">
                                        <span className="faq-icon">{item.icon}</span>
                                        <div>
                                            <p className="faq-category">{item.category}</p>
                                            <h4 className="faq-question">{item.question}</h4>
                                        </div>
                                    </div>
                                    <span className="faq-toggle">{isOpen ? <FaChevronUp /> : <FaChevronDown />}</span>
                                </button>
                                {isOpen && (
                                    <div className="faq-body">
                                        <p>{item.answer}</p>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default PreguntasFrecuentes;
